var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 29C7.268 29 1 22.732 1 15S7.268 1 15 1s14 6.268 14 14-6.268 14-14 14m0-10 .05.05 1-1L15 17l-3-3-1 1 2 2H5v2h8.007L11 21l1 1 3-2.99-.01-.01zm1.025-4.975L19 17l1-1-2-2h7v-2h-6.95l2-2-1-1-3 3H15v2h.95l.05.05zM15 0c8.285 0 15 6.716 15 15 0 8.285-6.715 15-15 15S0 23.285 0 15 6.716 0 15 0"
  })));
});
const SvgWorkflowStepReassignIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWorkflowStepReassignIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDI5QzcuMjY4IDI5IDEgMjIuNzMyIDEgMTVTNy4yNjggMSAxNSAxczE0IDYuMjY4IDE0IDE0LTYuMjY4IDE0LTE0IDE0em0wLTEwbC4wNS4wNSAxLTFMMTUgMTdsLTMtMy0xIDEgMiAySDV2Mmg4LjAwN0wxMSAyMWwxIDEgMy0yLjk5LS4wMS0uMDFIMTV6bTEuMDI1LTQuOTc1TDE5IDE3bDEtMS0yLTJoN3YtMmgtNi45NWwyLTItMS0xLTMgM0gxNXYyaC45NWwuMDUuMDUuMDI1LS4wMjV6TTE1IDBjOC4yODUgMCAxNSA2LjcxNiAxNSAxNSAwIDguMjg1LTYuNzE1IDE1LTE1IDE1LTguMjg0IDAtMTUtNi43MTUtMTUtMTVDMCA2LjcxNiA2LjcxNiAwIDE1IDB6Ii8+Cjwvc3ZnPgo=";